

import RecipientSnippet from './view-recipient-snippet';
import CollectionView   from '../../poppet/collection-view';

export const RecipientCollectionView = CollectionView.extend( {
	childView: RecipientSnippet,
} );
export default RecipientCollectionView;